import parametros from "@/locales/languages/es_MX/view/generales/parametros";
import plantillaCorreo from "@/locales/languages/es_MX/view/generales/plantillaCorreo";
import archivos from "@/locales/languages/es_MX/view/generales/archivos";

export default {
  parametros
  , plantillaCorreo
  , archivos
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/generales/index.js